import { ApiResponse } from 'apisauce';

import { IdVerificationProviders } from '@barboxx/types';
import type {
    Authentication,
    Customer,
    CustomerIdVerification,
    PasswordToken,
} from '@barboxx/models/types';

import { api } from '../../api';
import { publicApi } from '../../publicApi';

// Customers
export function emailCheck(query: { email: string }) {
    return publicApi.get<Customer>(`auth/customer`, query);
}

export function login(userInfo: Authentication.CustomerLoginRequest) {
    return publicApi.post<Authentication.CustomerAuthReturn>(
        'auth/customer/login',
        userInfo,
        {
            withCredentials: true,
        }
    );
}

// Generated by Copilot
let refreshTokenPromise: Promise<
    ApiResponse<Authentication.CustomerAuthReturn>
> | null = null;

export function refreshExpiredToken(query?: { refreshToken: string }) {
    if (!refreshTokenPromise) {
        refreshTokenPromise = publicApi
            .get<Authentication.CustomerAuthReturn>(
                'auth/customer/token',
                query,
                {
                    withCredentials: true,
                }
            )
            .finally(() => {
                refreshTokenPromise = null;
            });
    }
    return refreshTokenPromise;
}

export function signup(user: Customer.CreateRequest) {
    return publicApi.post('auth/customer', user);
}

export function forgotPassword(data: Authentication.ForgotPasswordRequest) {
    return publicApi.post('auth/customer/password', data);
}

export function resetPassword(data: PasswordToken.ResetPasswordRequest) {
    return publicApi.put('auth/customer/password', data);
}

export function logout() {
    return api.get<undefined>('auth/customer/logout', undefined, {
        withCredentials: true,
    });
}

// export function createStripeVerificationSession(
//     data: Omit<CustomerIdVerification.CreateVerificationRequest, 'provider'>
// ) {
//     return throwIfBadResponse(
//         publicApi.post<CustomerIdVerification.StripeCreateVerificationSessionResponse>(
//             'auth/customer/create-verification-session',
//             { ...data, provider: 'Stripe' }
//         )
//     );
// }

// export function getStripeVerificationSession(
//     query: Omit<CustomerIdVerification.GetVerificationRequest, 'provider'>
// ) {
//     return publicApi.get<CustomerIdVerification.StripeVerificationSessionResponse>(
//         'auth/customer/verification-session',
//         { ...query, provider: 'Stripe' }
//     );
// }

export function createPersonaVerificationSession(
    data: Omit<CustomerIdVerification.CreateVerificationRequest, 'provider'>
) {
    return publicApi.post<CustomerIdVerification.PersonaCreateVerificationSessionResponse>(
        'auth/customer/create-verification-session',
        { ...data, provider: 'Persona' }
    );
}

export function getPersonaVerificationSession(
    query: Omit<CustomerIdVerification.GetVerificationRequest, 'provider'>
) {
    return publicApi.get<CustomerIdVerification.PersonaGetVerificationSessionResponse>(
        'auth/customer/verification-session',
        { ...query, provider: 'Persona' }
    );
}

export function getVerificationSessionProvider(
    query: Omit<CustomerIdVerification.GetVerificationRequest, 'provider'>
) {
    return publicApi.get<IdVerificationProviders | null>(
        'auth/customer/verification-session/provider',
        { ...query }
    );
}
